import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = ["id", "checked", "disabled", "data-qa"]
const _hoisted_3 = { class: "check-label" }

interface Props {
  modelValue: boolean;
  id: string;
  label: string;
  disabled?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VitaCheckbox',
  props: {
    modelValue: { type: Boolean },
    id: {},
    label: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;

const handleChange = (event: Event) => {
  const target = event.target as HTMLInputElement;
  emit("update:modelValue", target.checked);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: "checkbox",
    "data-qa": `checkbox-${__props.id}-label-toggle`
  }, [
    _createElementVNode("input", {
      id: __props.id,
      type: "checkbox",
      class: "checkbox-input",
      checked: __props.modelValue,
      onChange: handleChange,
      disabled: __props.disabled,
      "data-qa": `checkbox-${__props.id}-input-toggle`
    }, null, 40, _hoisted_2),
    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "check-icon" }, null, -1)),
    _createElementVNode("span", _hoisted_3, _toDisplayString(__props.label), 1)
  ], 8, _hoisted_1))
}
}

})